import { Temporal } from 'temporal-polyfill'

export const DAY_ROWS: Array<{ dayIndex: number }> = [
  { dayIndex: 0 },
  { dayIndex: 1 },
  { dayIndex: 2 },
  { dayIndex: 3 },
  { dayIndex: 4 },
  { dayIndex: 5 },
  { dayIndex: 6 },
]

export const SLOT_INTERVAL_MINUTES = 15
export const SLOT_DEFAULT_DURATION_MINUTES = 60
export const START_TIME_OPTIONS = Array.from(
  { length: (24 * 60) / SLOT_INTERVAL_MINUTES },
  (_, index) => index * SLOT_INTERVAL_MINUTES,
)
export const END_TIME_OPTIONS = Array.from(
  { length: (24 * 60) / SLOT_INTERVAL_MINUTES },
  (_, index) => (index + 1) * SLOT_INTERVAL_MINUTES,
)
export const DEFAULT_SLOT_START_MINUTES = 9 * 60
export const DEFAULT_SLOT_END_MINUTES = 17 * 60

export const minutesToLabel = (minutes: number): string => {
  const normalized = ((minutes % 1440) + 1440) % 1440
  const hour24 = Math.floor(normalized / 60)
  const mins = normalized % 60
  const period = hour24 >= 12 ? 'pm' : 'am'
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12
  return `${hour12}:${mins.toString().padStart(2, '0')} ${period}`
}

export const minutesFromZdt = (zdt: Temporal.ZonedDateTime): number => {
  return zdt.hour * 60 + zdt.minute
}

export const buildDateForDayAndMinutes = (
  dayIndex: number,
  minutes: number,
): Date => {
  const date = new Date()
  const deltaToDay = dayIndex - date.getDay()
  date.setDate(date.getDate() + deltaToDay)

  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  date.setHours(hours, mins, 0, 0)

  return date
}
